module.exports = __webpack_public_path__ + "static/vakif-5-17c047ef6540f511b88fa9708fa17ef1.png";